import { AppDispatch } from './../index';
import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import account, { accountSaga } from './account';
import user, { userSaga } from './user';
import diagnosis, { diagnosisSaga } from './diagnosis';
import scalp, { scalpSaga } from './scalp';
import quiz, { quizSaga } from './quiz';
import hairlossProgress, { hairlossProgressSaga } from './hairlossProgress';
import loading from './loading';
import status from './status';
import shampoo, { shampooSaga } from './shampoo';
import { TKitInfo } from 'service/product';
import cart, { CartInitType } from 'toolkit/cart/cartSlice';
import delivery, { DeliveryInitType } from 'toolkit/delivery/deliverySlice';
import point, { PointInitType } from 'toolkit/point/pointSlice';
import telemedicineSlice from './telemedicine';
import { ITelemedicineSlice } from './telemedicine';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

// TODO: 각각의 reducer 타입 선언 후 파일 분리

type QuizInitType = {
  quizState: [];
  quizSubmitLoading: boolean;
  quizSubmitDone: boolean;
  quizSubmitError: boolean;
  userQuizData: {};
  kit: TKitInfo[];
  issues: [];
  beconShampoo: boolean;
};
const rootReducer = combineReducers<{
  account: any;
  user: any;
  diagnosis: any;
  scalp: any;
  loading: any;
  hairlossProgress: any;
  status: any;
  shampoo: any;
  quiz: QuizInitType;
  cart: CartInitType;
  delivery: DeliveryInitType;
  point: PointInitType;
  telemedicineSlice: ITelemedicineSlice;
}>({
  account,
  user,
  diagnosis,
  scalp,
  loading,
  hairlossProgress,
  status,
  shampoo,
  quiz,
  cart,
  delivery,
  point,
  telemedicineSlice,
});

export function* rootSaga() {
  yield all([
    accountSaga(),
    userSaga(),
    diagnosisSaga(),
    scalpSaga(),
    hairlossProgressSaga(),
    shampooSaga(),
    quizSaga(),
  ]);
}

export type RootState = ReturnType<typeof rootReducer>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default rootReducer;
